<template lang="html">
  <section class="actionsheet-wrapper">
    <transition name="actionsheet-mask">
      <div
        class="mask mask-transparent"
        @click="hideActionSheet"
        v-show="action"
      ></div>
    </transition>
    <div class="actionsheet" :class="{ 'actionsheet-toggle': action }">
      <actionTitle
        :title="actionHeader.title"
        :isShow="actionHeader.show"
      ></actionTitle>
      <div class="actionsheet-bd" :class="{ noTitle: !actionHeader.show }">
        <component :is="viewName" :params="params"></component>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import confirmAddress from '@/components/confirm/selectAddress'
import workers from '@/components/work'
import confirmWorkers from './confirm/workers'
import calendar from './date-sheet'
import actionTitle from './confirmActionTitle'
import addressSheet from './address-sheet'
import areaSelect from '../address/atom/choose'
import serveExplain from './labels-sheet'
import coupon from './coupon-sheet'
import city from './city-sheet'
import enteringCity from '../entering/entering-city-sheet'
import storeList from './storeList'
import studentNotice from './student-notice'
import selfphotoNotice from './selfphoto-notice'
import addUserForInsurance from '@/components/confirm/addUserForInsurance'

export default {
  props: {
    viewName: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    const actionsheet = document.querySelector('.actionsheet')
    if (actionsheet) {
      actionsheet.addEventListener('transitionend', () => {
        if (!this.action) {
          this.changeView('')
        }
      })
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.scrollTop = document.body.scrollTop
        document.body.scrollTop = 0
        document.body.classList.add('of-hide')
        document.documentElement.classList.add('of-hide')
      } else {
        document.body.classList.remove('of-hide')
        document.documentElement.classList.remove('of-hide')
        document.body.scrollTop = this.scrollTop
      }
    }
  },
  computed: {
    ...mapState({
      isShow: 'isActionSheetShow',
      actionHeader: 'actionHeader'
    }),
    action() {
      const action = this.$route.query.action || false
      if (action) {
        this.showActionSheet()
      } else {
        this.hideActionSheet()
      }
      return action
    }
  },
  methods: {
    ...mapMutations(['hideActionSheet', 'showActionSheet', 'changeView'])
  },
  components: {
    actionTitle,
    calendar,
    workers,
    confirmWorkers,
    addressSheet,
    areaSelect,
    confirmAddress,
    serveExplain,
    coupon,
    city,
    enteringCity,
    storeList,
    studentNotice,
    selfphotoNotice,
    addUserForInsurance,
    confirmYuesaoCity: () => import('./confirmYuesao/confirmYuesaoCity'),
    confirmYuesaoWorkers: () => import('./confirmYuesao/confirmYuesaoWorkers'),
    confirmYuesaoAddress: () => import('./confirmYuesao/confirmYuesaoAddress')
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.mask,
.mask-transparent {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.mask {
  //background: rgba(0, 0, 0, .6)
}
.actionsheet {
  position: fixed;
  left: 100%;
  top: 0;
  // transform: translate(100%, 0);
  backface-visibility: hidden;
  z-index: 50;
  width: 100%;
  height: 100%;
  background-color: #fff;
  // transition: transform .3s;
  //transition: left .3s;

  .actionsheet-bd {
    position: absolute;
    top: rem(80px);
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    &.noTitle {
      top: 0;
    }
  }
}
.actionsheet-toggle {
  // transform: translate(0, 0);
  left: 0;
}
.actionsheet-mask-enter,
.actionsheet-mask-leave-active {
  opacity: 0;
}
.actionsheet-mask-leave-active,
.actionsheet-mask-enter-active {
  transition: opacity 300ms;
}
</style>
